import { CssBaseline, ThemeProvider, createTheme } from "@mui/material";
import BookBarcodeAdmin from "./page/adminPage/BookBarcodeAdmin";

const barcodeRegistrationTheme = createTheme({
  typography: {
    fontFamily: "Pretendard, sans-serif",
  },
  palette: {
    primary: {
      main: "#2E3341",
      contrastText: "#fff",
    },
    error: {
      main: "#ff000090",
      contrastText: "#fff",
    },
  },
});

/**
 * Standalone entry point for the pre-renewal barcode registration site.
 * It deliberately does not initialise the normal application shell or login flow.
 */
const BarcodeRegistrationApp = () => (
  <ThemeProvider theme={barcodeRegistrationTheme}>
    <CssBaseline />
    <main className="barcode-registration-app">
      <BookBarcodeAdmin />
    </main>
  </ThemeProvider>
);

export default BarcodeRegistrationApp;
